import { NavLink } from 'react-router-dom';

const EXPLORE = [
  { to: '/', label: 'Home', end: true },
  { to: '/leaderboards', label: 'Leaderboards' },
  { to: '/benefits', label: 'Benefits' },
  { to: '/raffles', label: 'Raffles' },
  { to: '/store', label: 'Store' },
  { to: '/cases', label: 'Cases' },
];

const INFO = [
  { to: '/terms', label: 'Terms of Service' },
  { to: '/privacy', label: 'Privacy Policy' },
];

function FooterLink({ to, label, end }) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        `text-left hover:text-[#ff544a] transition-colors cursor-pointer ${
          isActive ? 'text-[#ff544a] font-bold' : ''
        }`
      }
    >
      {label}
    </NavLink>
  );
}

export default function Footer() {
  return (
    <footer className="bg-black border-t border-[#ff544a]/20 w-full py-10 mt-16 relative z-10">
      <div className="max-w-[1200px] mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-8">
        <div className="flex flex-col gap-4 text-center md:text-left">
          <div className="font-display-lg text-2xl font-black italic text-[#ff544a] drop-shadow-[0_0_8px_rgba(255,84,74,0.6)]">
            FREEMANSLIVE
          </div>
          <div className="font-mono-brand text-xs text-[#888899] tracking-wider leading-relaxed">
            © 2026 FREEMANSLIVE.
            <br />
            ALL RIGHTS RESERVED.
          </div>
          <div className="font-mono-brand text-xs text-[#888899] tracking-wide">
            Business email:{' '}
            <a href="mailto:Freemanthe3rd@gmail.com" className="text-[#ff544a] hover:underline font-bold">
              Freemanthe3rd@gmail.com
            </a>
          </div>
        </div>

        <div className="flex gap-16">
          <div className="flex flex-col gap-3">
            <h4 className="font-mono-brand text-sm font-bold text-white uppercase tracking-widest">Explore</h4>
            <nav className="flex flex-col gap-2 font-mono-brand text-xs text-[#888899]">
              {EXPLORE.map((l) => (
                <FooterLink key={l.to} {...l} />
              ))}
            </nav>
          </div>
          <div className="flex flex-col gap-3">
            <h4 className="font-mono-brand text-sm font-bold text-white uppercase tracking-widest">Information</h4>
            <nav className="flex flex-col gap-2 font-mono-brand text-xs text-[#888899]">
              {INFO.map((l) => (
                <FooterLink key={l.to} {...l} />
              ))}
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
}
